import React from 'react';
import classNames from 'classnames';
import ImageWithPlaceholder from 'src/Components/ImageWithPlaceholder';
import styles from './styles.module.scss';
import { CosmeticRarity, CosmeticType, currencyIconMap, currencyName } from 'src/utils/types';
import icBuy from 'assets/svg/ic_cart.svg';
import Spinner from 'src/Components/Spinner';
import { formatCurrency, formatCurrencyInFiat } from '@wolffun/system-currency';
import { formatParamPath, webImageUri } from 'src/utils/uri';
import { useTypedSelector } from 'src/redux/utils';
import { parseCosmeticType } from 'src/Pages/MarketplaceV2/Components/MarketCosmetic/utils';
import { getTimeSince } from 'src/utils/date';
const cosmeticRarityStyleMap = {
  [CosmeticRarity.COMMON]: styles.common,
  [CosmeticRarity.EPIC]: styles.epic,
  [CosmeticRarity.LEGENDARY]: styles.legendary
};
const CosmeticCard = /*#__PURE__*/React.forwardRef(({
  className,
  cosmetic,
  onPress
}, ref) => {
  const {
    imgPathPattern
  } = useTypedSelector(state => state.cosmeticItemsConfigs);
  const heroRarityClassName = cosmeticRarityStyleMap[cosmetic.cosmeticRarity];

  const renderStatus = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.wrapStatus
    }, /*#__PURE__*/React.createElement("img", {
      src: icBuy,
      className: styles.icStatus
    }), /*#__PURE__*/React.createElement("span", {
      className: styles.spanStatus
    }, "Buy"));
  };

  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classNames(className, styles.container),
    onClick: onPress
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.bgCard
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.shape, styles.background)
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(ImageWithPlaceholder, {
    className: classNames(styles.portrait, cosmetic.cosmeticType !== CosmeticType.SPACESHIP && styles.smallPortrait),
    src: webImageUri(formatParamPath(imgPathPattern, {
      id: cosmetic.cosmeticInfo.typeId
    })),
    renderPlaceholder: () => /*#__PURE__*/React.createElement(Spinner, {
      secondary: true,
      size: "50%",
      className: classNames(styles.portrait, styles.spinner)
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.inner
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.itemInfo, heroRarityClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.wrapInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.line, heroRarityClassName)
  }), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.tokenId, heroRarityClassName)
  }, cosmetic.cosmeticName), /*#__PURE__*/React.createElement("span", {
    className: styles.name
  }, parseCosmeticType(cosmetic.cosmeticType))), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapTime
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Released time "), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, getTimeSince(new Date(cosmetic.timestamp))))), /*#__PURE__*/React.createElement("div", {
    className: styles.statsItem
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.priceWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Price"), /*#__PURE__*/React.createElement("div", {
    className: styles.priceValue
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.mainWrapper
  }, cosmetic.saleInfo.price && currencyIconMap[cosmetic.saleInfo.price.token] && /*#__PURE__*/React.createElement("img", {
    draggable: false,
    src: currencyIconMap[cosmetic.saleInfo.price.token],
    className: styles.icon
  }), cosmetic.saleInfo.price && /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, formatCurrency(cosmetic.saleInfo.price, {
    withCurrency: false,
    trimWholeFraction: true
  }), "\xA0", /*#__PURE__*/React.createElement("span", {
    className: styles.unit
  }, currencyName[cosmetic.saleInfo.price.token]))), cosmetic.saleInfo.price && /*#__PURE__*/React.createElement("span", {
    className: styles.subValue
  }, "$\xA0", formatCurrencyInFiat(cosmetic.saleInfo.price, {
    withCurrency: true,
    trimWholeFraction: true
  }))))), renderStatus())));
});
CosmeticCard.displayName = 'CosmeticCard';
export default CosmeticCard;